import cx from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import { FunctionComponent } from 'react';

import useLinkProps from '../../../hooks/use-link-props';
import Carousel from '../../ui/v2/carousel';
import BackgroundLink from '../../ui/links/background';
import ImageLabel from '../../ui/v2/products/image-label';

const SimilarVehicles: FunctionComponent<{ vehicles: Array<TVehicleCard> }> = ({
  vehicles,
}) => {
  const { t } = useTranslation();
  const getLink = useLinkProps();
  return (
    <div className={cx('bg-neutral-10',
      'container',
      'mx-auto',
      'text-center',
      'lg:px-4',
      'pt-8',
      'pb-12')}>
      <h2 className={cx('text-[22px] lg:text-[32px]', 'font-bold')}>
        {t('unique-vehicle:similar_vehicles')}
      </h2>
      <div>{t('unique-vehicle:find_more_parts')}</div>
      {vehicles && (
        <Carousel
          perPage={4}
          items={vehicles.map((vehicle) => ({
            value: (
              <BackgroundLink
                variant="DEFAULT"
                {...getLink('vehicle', {
                  vehicle: vehicle.slug,
                })}
                shallow
                prefetch={false}
                scroll
              >
                <ImageLabel product={vehicle} isVehicle />
              </BackgroundLink>
            ),
            key: vehicle.id.toString(),
          }))}
        />
      )}
    </div>
  );
};

export default SimilarVehicles;
